import cn from 'classnames'
import {FC, ReactNode} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {MODAL_WIDTH} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type ModalBodyProps = {
  title: string | ReactNode
  titleVariant?: TextVariant
  icon?: ReactNode
  image?: ReactNode
  description?: string | ReactNode
  descriptionVariant?: TextVariant
  isCentered?: boolean
  minWidth?: string
  maxWidth?: string
}

export const ModalBody: FC<React.PropsWithChildren<ModalBodyProps>> = ({
  title,
  titleVariant = TextVariant.h6,
  icon,
  image,
  description,
  descriptionVariant = TextVariant.text14,
  isCentered = false,
  minWidth = MODAL_WIDTH,
  maxWidth = minWidth,
  children,
}) => (
  <>
    <div className={cn('content', isCentered && 'centered')}>
      <div className="header">
        {icon ? <div className="icon">{icon}</div> : image ? image : null}
        {title && (
          <Text variant={titleVariant} element="h2">
            {title}
          </Text>
        )}
        {description && (
          <div className="description">
            <Text
              variant={descriptionVariant}
              fontWeight={TextFontWeight.regular}
              color={theme.palette.text.light}
            >
              {description}
            </Text>
          </div>
        )}
      </div>
      {children}
    </div>

    <style jsx>{`
      .content {
        min-width: ${minWidth};
        max-width: ${maxWidth};
        height: 100%;
      }
      .centered .header {
        text-align: center;
      }
      .header {
        margin-bottom: ${theme.spacing[4]};
      }
      .icon {
        display: flex;
        justify-content: center;
        margin-bottom: ${theme.spacing[3]};
      }
      .description {
        margin-top: ${theme.spacing[2]};
      }
      @media ${MOBILE_SCREENSIZE} {
        .content {
          min-width: inherit;
          max-width: inherit;
        }
      }
    `}</style>
  </>
)
